module.exports = __webpack_public_path__ + "static/media/index_banner.548ba9a1.png";